module.exports = __webpack_public_path__ + "static/media/homeSupplier.02f3d50a.svg";